import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getScreenById } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useOccDisplayText } from '../../../../../context/occ/hooks/use-occ-display-text';
import { getHeroAttributesForShowtime, getShowtimeAttributes } from '../../../../attribute-list/utils';
const b = bemClassBuilder('v-showtime-dropdown-option');
const defaultShowtimeFormat = 'h:mm A';
export const ShowtimeDropdownOptionTemplate = props => {
    const { showtime: showtimeDisplayText } = useOccDisplayText();
    const { text, attribute, screenName, isSoldOut } = props;
    return (_jsxs("div", Object.assign({ className: b.block({ isSoldOut }) }, { children: [_jsxs("div", Object.assign({ className: b.element('schedule') }, { children: [_jsx("span", Object.assign({ className: b.element('showtime') }, { children: text })), isSoldOut ? (_jsx("span", Object.assign({ className: b.element('sold-out') }, { children: showtimeDisplayText.soldOutLabel }))) : (_jsx("span", Object.assign({ className: b.element('attribute') }, { children: attribute })))] })), screenName && _jsx("span", Object.assign({ className: b.element('screen-name') }, { children: screenName }))] })));
};
ShowtimeDropdownOptionTemplate.displayName = 'ShowtimeDropdownOptionTemplate';
export const ShowtimePreviewDropdownOptionTemplate = props => {
    const { text, attribute } = props;
    return (_jsx("div", Object.assign({ className: b.block({ preview: true }) }, { children: _jsxs("div", Object.assign({ className: b.element('schedule') }, { children: [_jsx("span", Object.assign({ className: b.element('showtime') }, { children: text })), _jsx("span", Object.assign({ className: b.element('attribute') }, { children: attribute }))] })) })));
};
ShowtimePreviewDropdownOptionTemplate.displayName = 'ShowtimePreviewDropdownOptionTemplate';
export const getDropdownOptionsForShowtimes = (showtimes, i18n, config) => {
    const showtimeFormat = (config === null || config === void 0 ? void 0 : config.showtimeFormat) || defaultShowtimeFormat;
    return showtimes.map(showtime => {
        const { schedule, screenId } = showtime;
        const attributes = getShowtimeAttributes([showtime]);
        const heroAttribute = getHeroAttributesForShowtime(attributes, i18n)[0];
        const screen = getScreenById(screenId);
        const showtimeDropdownOption = {
            text: i18n.date(schedule.startsAt, {
                format: showtimeFormat,
                ianaTimeZoneName: config === null || config === void 0 ? void 0 : config.ianaTimeZoneName
            }),
            value: showtime.id,
            disabled: showtime.isSoldOut,
            attribute: i18n.translatable(heroAttribute === null || heroAttribute === void 0 ? void 0 : heroAttribute.name),
            screenName: (config === null || config === void 0 ? void 0 : config.showScreenName) ? i18n.translatable(screen === null || screen === void 0 ? void 0 : screen.name) : undefined,
            isSoldOut: showtime.isSoldOut
        };
        return showtimeDropdownOption;
    });
};
